import { Form } from "react-bootstrap"
import React from "react"
import BaseControl from "./BaseControl"

interface SwitchControlProps {
    text?: string;
    caption?: string;
    edit?: boolean;
    value?: boolean;
    enabled?: boolean; // when false, BaseControl renders a "Coming Soon" badge and dims the row
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    onChanged?: (val: boolean) => void;
}

const SwitchControl = ({
    text = "Text",
    caption = "",
    edit = true,
    value = true,
    enabled = true,
    icon,
    onChanged = (val: boolean) => {} }: SwitchControlProps) => {
    const _onChanged = (val: any) => {
        //console.log(val.target.checked)
        onChanged(val.target.checked);
    }
    return <BaseControl text={text} caption={caption} enabled={enabled} icon={icon}>
        <>
        { <Form.Check
            disabled={!edit || !enabled}
            type="switch"
            checked={value}
            onChange={_onChanged}/>}
        </>
    </BaseControl>
}

export default SwitchControl